import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import TokenService from "../../Services/Token.service";
import Loader from "../../Components/Loader";

function ProtectedComponent(props) {
    const { Component, requiredRole } = props; 
    const userRestrictions = TokenService.getUserRestrictions() || [];
    const navigate = useNavigate();
    const location = useLocation();  
    const [userRoles, setUserRoles] = useState([]);
    const [isAuthenticated, setIsAuthenticated] = useState(null); 
    const [initialRedirectDone, setInitialRedirectDone] = useState(false);

    
    useEffect(() => {
        const user = TokenService.getUser();
        if (user) {
            setIsAuthenticated(true);
            setUserRoles(user.roles || []);            
        } else {
            setIsAuthenticated(false);
        }
    }, []);
    
    useEffect(() => {    


        if (isAuthenticated === null || initialRedirectDone) return;

        const currentUrl = location.pathname;
        const lastSlug = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
        const restrictedArr = typeof userRestrictions === 'string' ? JSON.parse(userRestrictions) : userRestrictions;

       
        if (!isAuthenticated) {
            navigate("/login");
            setInitialRedirectDone(true);
        } else if (isAuthenticated) {
            
            //code for session timeout page restriction when used is loged in and not times out if user enters /session-timeout url manually
            if (location.pathname === "/session-timeout") {
                const timeoutFlag = localStorage.getItem("app_session_timed_out");

                if (!isAuthenticated) {
                    navigate("/login");
                    setInitialRedirectDone(true);

                    return;
                }

                if (!timeoutFlag) {
                    navigate("/not-authorized");
                    setInitialRedirectDone(true);
                    return;
                }
                //  Valid session timeout redirect
                // localStorage.removeItem("app_session_timed_out"); // allow only once
                return;
            }


            const userHasRole = 
                requiredRole &&
                userRoles.length > 0 &&
                !userRoles.map(role => role.toLowerCase()).includes(requiredRole.toLowerCase()) &&
                !userRoles.map(role => role.toLowerCase()).includes('superadmin');

            const userHasRestriction = 
                restrictedArr &&
                restrictedArr.length > 0 &&
                lastSlug != '' &&
                userRestrictions.includes(lastSlug);


            if (userHasRole || userHasRestriction) {
                if (userRoles.includes('Donor')) {
                    navigate('/donor/upcoming-donations');
                } else {
                    navigate('/not-authorized');
                }
                setInitialRedirectDone(true);
            } else if (location.pathname === '/') {
                // Redirect based on roles
                if (userRoles.includes('Admin') || userRoles.includes('Superadmin')) {
                    // navigate('/admin/dashboard');
                    navigate('/admin/sample-requests');
                } else if (userRoles.includes('Donor')) {
                    // navigate('/donor/dashboard');
                    navigate('/donor/job-board');
                } else if (userRoles.includes('Requestor')) {
                    // navigate('/requestor/dashboard');
                    navigate('/requestor/requestor-sample-requests');
                }
                setInitialRedirectDone(true);
            }
        }

    }, [isAuthenticated, userRoles, requiredRole, location.pathname, navigate, initialRedirectDone, userRestrictions]);


    if (isAuthenticated === null) {
        return <Loader loading={true} />;
    }

    if (!isAuthenticated) {
        return null;
    }

    return (
        <Fragment>
            <Component />
        </Fragment>
    );
}

export default ProtectedComponent;
